<template>
  <v-layout wrap>
    <v-flex xs12 v-if="localized" class="text-xs-center">
      <h4 class="grey--text">Localized image</h4>
      <ImageInput v-model="image" :suggest="suggest" :actions-bottom="true" :disable-clear="true" :aspect-ratio="aspectRatio"/>
      <p class="text-xs-center">
        <v-btn @click="useOriginalImage()">Use parent image</v-btn>
      </p>
    </v-flex>
    <v-flex xs12 v-else>
      <v-img :contain="true" :src="original | ifEmpty(require('../assets/No_Image_Available.jpg'))" max-height="300"/>
      <p class="text-xs-center">
        <v-btn @click="useLocalizedImage()">Replace by localized image</v-btn>
      </p>
    </v-flex>
  </v-layout>
</template>

<script>
import ImageInput from './ImageInput'
export default {
  components: { ImageInput },
  props: ['value', 'original', 'suggest', 'aspectRatio'],
  data () {
    return {
      localized: false
    }
  },
  computed: {
    image: {
      set (val) {
        this.$emit('input', val)
      },
      get () {
        return this.value
      }
    }
  },
  created () {
    this.localized = !!this.value
  },
  methods: {
    useLocalizedImage () {
      this.localized = true
    },
    useOriginalImage () {
      this.localized = false
      this.image = null
    }
  }
}
</script>
